import React, { Component } from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import BarChart from "layouts/BarChart";
import Sidebar from "../Sidebar";
import "./dashboard.css";
import { autoRun, topTenD, topTenN, passThroughData } from "./dashBoardData";
import { dateRange } from "./dashBoardData";
import API from "../../Api/index";
import { NotificationManager } from "react-notifications";
import moment from 'moment';
import LineCharts from "layouts/LineChart/lineChart";
import { Box, CircularProgress, Typography } from "@mui/material";
import StackedBarChart from "layouts/BarChart/StackedBarChart";

/**
 * set global varible to filter initially data for "month to date"
 */
const date = new Date();
const today = new Date().toISOString().substring(0, 10);
var initialDate = today;
var finalDate = new Date(date.getFullYear(), date.getMonth(), 2).toISOString().substring(0, 10);

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      practiceData: [],
      customSetPractice: () => { },
      valueOfdateRange: '',
      dataofGraph: {
        labels: [],
        datasets: [
          {
            label: "NotReviewed",
            data: [],
            backgroundColor: "#5CB02C",
          },
        ],
      },
      dataOfProcessedClaims: {
        labels: [],
        datasets: [
          {
            label: "Claims",
            data: [],
            borderColor: "#5CB02C",
            backgroundColor: "#5CB02C",
            borderWidth: 3,
            pointRadius: 5,
          },
        ],
      },
      workloadUser: 'All Users',
      workloadFilter: 'This Week',
      workloadUpdateFilter: 'Claim Scrubber',
      assignTo: [],
      pvUsers: [],
      totalEncounters: 0,
      loading: false,
      processVolumeData: [],
      assignedVsAssignedTo: [],
      filterByUser: "All Users",
      filterBy: "workedVsEntered",
      processedUpdateFilter: "denial",
      practiceFilter: '0',
      dateByRange: "month_to_date",
      topTenFilter: 'denial',
      topTenPractice: JSON.parse(sessionStorage.getItem('practice'))?.id,
      topTenWorklist: [],
      passThroughPractice: '0',
      passThroughFilter: 'denial',
      workvsenterFilter: 'denial',
      wedata: null,
      weoptions: null
    };
  }

  /**
   * @returns function to handle practice data with status "on" and "off"
   */
  fetchPractice = () => {
    API.get("allPractices")
      .then((res) => {
        this.setState({ practiceData: res.data.data.filter(practice => practice.status) });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /**
   * function to handle bar graph of practice reviewed in workload
   */
  getWorkloadReviewed = () => {
    API.get("getPracticeReviewed")
      .then((res) => {
        let reviewedCount = [];
        let practiceReviewed = [];
        res.data.practiceReviewed.map((reviewed) => {
          reviewedCount.push(reviewed.count);
          practiceReviewed.push(reviewed.practiceAcronym);
        });
        this.setState({
          dataofGraph: {
            labels: practiceReviewed,
            datasets: [
              {
                label: "NotReviewed",
                data: reviewedCount,
                backgroundColor: "#5CB02C",
              },
            ],
          },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * function to set practice change in sesssion storeg
   * on change in dropdown
   * @param {*} practice
   */
  savePracticeLocally = (practice) => {
    sessionStorage.setItem("practice", JSON.stringify(practice));
  };

  getSelectedPracticeLocally = () => {
    const practice = sessionStorage.getItem("practice");
    if (practice) {
      return JSON.parse(practice);
    }
  };

  /**
   * function to handle practice change in the dropdown to filter
   * processd claims line graph
  //  * @param {*} event
  //  */
  handlePracticeChange = (event) => {
    const selectedPracticeId = event.target.value;
    const selectedPractice = (this.state.practiceData || []).find(
      (practice) => practice.id == selectedPracticeId
    );
    if (selectedPractice && selectedPractice.id) {
      this.savePracticeLocally(selectedPractice);
      this.setState({ customSetPractice: selectedPractice })
    }
    this.setState({ practiceFilter: selectedPracticeId }, () => {
      this.getProcessedByVolumeGraph()
    });
  };

  /**
   * function to handle the date range change and get the required date
   * which is send in body of getProcessedClaimsGraph method
   * @param {*} e
   */
  handleDateRangeGraph = (e) => {
    let value = e.target.value;
    this.setState({ valueOfdateRange: value })
    const date = new Date();
    const today = new Date().toISOString().substring(0, 10);
    switch (value) {
      case "month_to_date":
        if (value === "month_to_date") {
          const month_date = new Date(date.getFullYear(), date.getMonth(), 2).toISOString().substring(0, 10);
          initialDate = today;
          finalDate = month_date;
        }
        break;
      case "year_to_date":
        if (value === "year_to_date") {
          const Year_to_date = new Date(date.getFullYear(), 0, 2).toISOString().substring(0, 10);
          initialDate = today;
          finalDate = Year_to_date;
        }
        break;
      default:
    }
    this.getProcessedClaimsGraph();
  };

  getDataForSelectedPractice = () => {
    let practice;
    let data = setInterval(() => {
      practice = sessionStorage.getItem("practice")
      if (practice) {
        this.getProcessedClaimsGraph();
        clearInterval(data)
      }
    }, 500)
  }

  /**
   * function to get line graph data by sending date range to filter and practice also
   */
  getProcessedClaimsGraph = () => {
    let body_data = {
      dateRange: {
        fromDate: initialDate,
        toDate: finalDate,
      },
    };
    API.post("getProcessedClaims", body_data)
      .then((claims) => {
        let claimsDate = [];
        let claimsCount = [];
        let modifiedDate = [];
        claims.data.processedClaims.map((dataOfClaims) => {
          claimsDate.push(dataOfClaims.currentDate);
          claimsCount.push(dataOfClaims.count);
        });
        for (var i = 0; i < claimsDate.length; i++) {
          let date = new Date(claimsDate[i])
          let d = date.getDate();
          let m = date.getMonth() + 1;
          let finalDate = (m <= 9 ? '0' + m : m) + '/' + (d <= 9 ? '0' + d : d);
          modifiedDate.push(finalDate)
        }
        this.setState({
          dataOfProcessedClaims: {
            labels: modifiedDate,
            datasets: [
              {
                label: "Claims",
                data: claimsCount,
                borderColor: "#5CB02C",
                backgroundColor: "#5CB02C",
                borderWidth: 3,
                pointRadius: 5,
              },
            ],
          },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // function to handle workload user
  handleWorkloadUser = (e) => {
    let { value } = e.target;
    this.setState({ workloadUser: value }, () => {
      this.getWorkloadData();
    })
  }

  // function to handle workload filter
  handleWorkloadFilter = (e) => {
    let { value } = e.target;
    this.setState({ workloadFilter: value }, () => {
      this.getWorkloadData();
    })
  }

  // function to handle workload filter
  handleWorkloadUpdateFilter = (e) => {
    let { value } = e.target;
    this.setState({ workloadUpdateFilter: value, workloadUser: "All Users" }, () => {
      this.getAssignToUsers()
      this.getWorkloadData();
    })
  }

  getAssignToUsers = () => {
    let { workloadFilter, workloadUpdateFilter } = this.state;
    let body_data = {
      dueDate: workloadUpdateFilter == "Claim Scrubber" ? "All" : workloadFilter,
      table: workloadUpdateFilter
    }
    API.post("/workloadByUsers", body_data)
      .then((result) => {
        if (result.data.success === true && result.data.workLoadByUsers.length) {
          let userArr = ["Danish", "Mahima", "Narendra", "Pappu", "Puneet", "Saurabh"]
          let userList = result.data.workLoadByUsers.filter(item => !userArr.includes(item));
          this.setState({ assignTo: userList });
          // setAssignTo(result.data.userList);
        }
      })
      .catch((error) => {
        NotificationManager.error(
          "Something Went wrong!",
          "Failure!",
          3000
        );
      });
  };

  getProcessedVolumeUsers = () => {
    API.get("/ProcessedVolumeUsers")
      .then((result) => {
        if (result.data.success === true && result.data.workLoadByUsers.length) {
          let userArr = ["Danish", "Mahima", "Narendra", "Pappu", "Puneet", "Saurabh"]
          let userList = result.data.workLoadByUsers.filter(item => !userArr.includes(item));
          this.setState({ pvUsers: userList });
        }
      })
      .catch((error) => {
        NotificationManager.error(
          "Something Went wrong!",
          "Failure!",
          3000
        );
      });
  };

  // function to get workload data
  getWorkloadData = () => {
    let { workloadUser, workloadFilter, workloadUpdateFilter } = this.state;
    let body_data = {
      user: workloadUser,
      dueDate: workloadUpdateFilter == "Claim Scrubber" ? "All" : workloadFilter,
      table: workloadUpdateFilter
    }
    API.post("workload", body_data).then((res) => {
      let reviewedCount = [];
      let practiceReviewed = [];
      let workloadData = res.data?.data;
      workloadData.map((reviewed) => {
        reviewedCount.push(reviewed.count);
        practiceReviewed.push(reviewed.practiceAcronym);
      });
      this.setState({
        dataofGraph: {
          labels: practiceReviewed,
          datasets: [
            {
              label: workloadUpdateFilter == "Claim Scrubber" ? "NotReviewed" : "Worklist",
              data: reviewedCount,
              backgroundColor: "#5CB02C",
            },
          ],
        },
        totalEncounters: reviewedCount.reduce((a, b) => a + Number(b), 0)
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  // functions to set processed volume filter values
  handleFilterByUser = (e) => {
    let { value } = e.target;
    this.setState({ filterByUser: value }, () => {
      this.getProcessedByVolumeGraph();
    });
  };
  handleProcessedFilter = (e) => {
    let { value } = e.target;
    this.setState({ processedUpdateFilter: value }, () => {
      this.getProcessedByVolumeGraph();
    });
  };
  handleFilterBy = (e) => {
    let { value } = e.target;
    this.setState({ filterBy: value }, () => {
      this.getProcessedByVolumeGraph();
    });
  };
  handleMonthToDate = (e) => {
    let { value } = e.target;
    this.setState({ dateByRange: value }, () => {
      this.getProcessedByVolumeGraph();
    });
  };

  // function to calculate processed volume graph
  getProcessedByVolumeGraph = () => {
    const {
      processedUpdateFilter,
      filterByUser,
      filterBy,
      dateByRange, practiceFilter
    } = this.state;
    this.setState({ loading: true });
    const body_data = {
      UpdateFilter: processedUpdateFilter,
      WorkedByUser:
        processedUpdateFilter === "claimScrubber" ? "" : filterByUser,
      FilterBy: processedUpdateFilter === "claimScrubber" ? "" : filterBy,
      DateRange: dateByRange,
      Practice: practiceFilter
    };
    API.post("processedVolume", body_data)
      .then((res) => {
        this.setState({
          processVolumeData: res.data.data || null,
          averages: res.data.averages || {
            workedAvg: 0,
            enteredAvg: 0,
            completedAvg: 0,
          }, // Ensure averages are set
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error fetching data:", error);
      });
  };

  // function to handle top ten filter
  handleTopTenFilter = (e) => {
    let { value } = e.target;
    this.setState({ topTenFilter: value }, () => {
      this.getTopTenWorklist();
    })
  }

  // function to handle top ten practice filter
  handleTopTenPracticeFilter = (e) => {
    let { value } = e.target;
    this.setState({ topTenPractice: value }, () => {
      this.getTopTenWorklist();
    })
  }

  // function to display top ten worklist
  getTopTenWorklist = () => {
    const { topTenFilter, topTenPractice } = this.state;
    let body_data = {
      PracticeId: topTenPractice
    }
    API.post('top_ten_worklist', body_data, { params: { filter_type: topTenFilter } }).then((res) => {
      this.setState({ topTenWorklist: res.data })
    }).catch((err) => {
      console.error(err)
    })
  }

  // function to handle pass through practice change
  handlePassThroughPractice = (e) => {
    let { value } = e.target;
    this.setState({ passThroughPractice: value })
  }

  // function to handle pass through filter
  handlePassThroughFilter = (e) => {
    let { value } = e.target;
    this.setState({ passThroughFilter: value })
  }

  // Helper method to generate the configuration for the "Pass Through Rate" card
  getPassThroughConfig = () => {
    // We modify the labels to include a newline character and the rate percentage below the month name
    const labels = passThroughData.map(d => `${d.month}\n${d.rate}%`);

    return {
      data: {
        labels: labels,
        datasets: [
          // The green part of the bar (the rate)
          { label: 'Pass Through Rate', data: passThroughData.map(d => d.rate), backgroundColor: '#5CB02C', stack: 'Stack 0', barPercentage: 0.5, categoryPercentage: 0.7 },
          // The red part of the bar (denials, calculated as 100 - rate)
          { label: 'Denials', data: passThroughData.map(d => 100 - d.rate), backgroundColor: '#954437', stack: 'Stack 0', barPercentage: 0.5, categoryPercentage: 0.7 },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true }, // Keep tooltips for interactivity
          datalabels: { display: false }, // No data labels needed on the bars themselves
        },
        scales: {
          x: {
            stacked: true,
            grid: { display: false },
            ticks: {
              // This function handles the newline for the month/percentage display
              callback: function (value, index) {
                return this.getLabelForValue(value).split('\n');
              },
              color: '#000', // Set a color for the labels if needed
            },
          },
          y: {
            display: false, // Hide the Y-axis entirely
            stacked: true,
            beginAtZero: true,
            max: 100,
          },
        },
      },
      metrics: { rate: 95, denials: 1526, resolved: '43,156', title: "Year to Date" }
    };
  }

  // function to handle pass through filter
  handleWorkVsEnterFilter = async (e) => {
    let { value } = e.target;
    this.setState({ workvsenterFilter: value }, async () => {
      const config = await this.getWorkedVsEnteredConfig();

      // 2. Update the specific state variables needed for your render function
      if (config) {
        this.setState({
          wedata: config.wedata,
          weoptions: config.weoptions
        });
      }
    })
  }

  // Helper method to generate the configuration for the "Worked vs Entered" card
  getWorkedVsEnteredConfig = async () => {
    let { workvsenterFilter } = this.state;
    let body_data = {
      filterType: workvsenterFilter
    }
    try {
      let res = await API.post('allWorkedVsEntered', body_data);
      let workData = res.data.data;
      return {
        wedata: {
          labels: workData.map(d => d.practice),
          datasets: [
            { label: 'Worklist', data: workData.map(d => d.amountReceived), backgroundColor: '#24476A', stack: 'Stack 0', barPercentage: 0.5, categoryPercentage: 0.7 },
            { label: 'Amount Pending', data: workData.map(d => d.amountPending), backgroundColor: '#3681A9', stack: 'Stack 0', barPercentage: 0.5, categoryPercentage: 0.7 },
            { label: 'Amount Completed', data: workData.map(d => d.amountCompleted), backgroundColor: '#5CB02C', stack: 'Stack 0', barPercentage: 0.5, categoryPercentage: 0.7 },
            { label: 'Late', data: workData.map(d => d.backlog), backgroundColor: '#954437', stack: 'Stack 0', barPercentage: 0.5, categoryPercentage: 0.7 },
          ],
        },
        weoptions: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            },
            datalabels: {
              display: false, // Hide labels for this specific chart
            },
          },
          scales: {
            x: { stacked: true, grid: { display: false } },
            y: { stacked: true, beginAtZero: true, grid: { display: true } },
          },
        },
        wemetrics: { title: "Last 90 Days" }
      };
    } catch (err) {
      console.error(err)
    }
  }


  async componentDidMount() {
    initialDate = today;
    finalDate = new Date(date.getFullYear(), date.getMonth(), 2).toISOString().substring(0, 10);
    // this.getWorkloadReviewed();
    this.fetchPractice();
    this.getDataForSelectedPractice();
    //  this.getProcessedClaimsGraph();
    this.getAssignToUsers();
    this.getProcessedVolumeUsers();
    this.getWorkloadData();
    this.getProcessedByVolumeGraph();
    this.getTopTenWorklist();

    // Handle the asynchronous call for the StackedBarChart data
    try {
      // 1. Use 'await' to wait for the Promise to resolve
      const config = await this.getWorkedVsEnteredConfig();

      // 2. Update the specific state variables needed for your render function
      if (config) {
        this.setState({
          wedata: config.wedata,
          weoptions: config.weoptions
        });
      }

    } catch (error) {
      console.error("Error in componentDidMount:", error);
      // Handle the error state in the UI if needed
      // this.setState({ error: true, isLoading: false });
    }
  }

  render() {
    const { practiceData, dataofGraph, dataOfProcessedClaims, workloadUser, workloadFilter, workloadUpdateFilter, assignTo, pvUsers, totalEncounters,
      loading, processVolumeData, filterBy, filterByUser, processedUpdateFilter, practiceFilter, topTenFilter, topTenPractice, topTenWorklist,
      passThroughPractice, passThroughFilter, workvsenterFilter, wedata, weoptions } = this.state;

    // Prepare data for the LineChart using graphData directly
    const graphData = processVolumeData.graphData;
    // Convert string counts to numbers for datasets
    graphData?.datasets?.forEach((dataset) => {
      dataset.data = dataset.data.map((count) => parseInt(count, 10)); // Ensure base 10 conversion
    });
    const hasData = graphData?.datasets.some((val) => val.data.length > 0);

    // Generate the full configuration objects using the helper methods
    const passThroughConfig = this.getPassThroughConfig();
    const { metrics, data, options } = passThroughConfig;

    return (
      <>
        <section style={{ backgroundColor: "white" }}>
          <Sidebar
            setSidebarDisable={true}
            customSetPractice={(customSetPractice) => {
              this.setState({ customSetPractice: customSetPractice });
            }}
            defaultDisabledValue={
              practiceData.id
            }
          />

          <div className="sectionlayoutcontainer homedashboard">
            <span className="dashboardText mb-2 w-100 h-auto">Dashboard</span>
            <div className="row ">
              <div className="col-lg-6 col-sm-6 mb-3">
                <Card className="workLoadCard p-0 h-100">
                  <CardHeader
                    className="workLoadHead"
                    title={
                      <h5 className="text-white font-face-futura">
                        Workload
                      </h5>
                    }
                  ></CardHeader>
                  <div className="mt-3 row w-100 px-3">
                    {/* {workloadUpdateFilter != "Claim Scrubber" && <div className="col-auto"> */}
                    <div className="col-auto">
                      <div className="d-flex align-items-center gap-2">
                        <label htmlFor="user" className="font-face-futura">Workload by User:</label>
                        <select className="copyDrop1" value={workloadUser} onChange={this.handleWorkloadUser}>
                          <option value="All Users">All Users</option>
                          <option value="Unassigned">Unassigned</option>
                          {assignTo.map((item) => (
                            <option value={item.id}>{item.fullName}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* <div className={workloadUpdateFilter != "Claim Scrubber" ? "col-auto" : "col-md-6"}> */}
                    <div className="col-auto">
                      <div className="d-flex align-items-center gap-2">
                        <label htmlFor="filter" className="font-face-futura">Filter By:</label>
                        <select className="copyDrop1" value={workloadFilter} onChange={this.handleWorkloadFilter}>
                          {workloadUpdateFilter != 'Claim Scrubber' &&
                            <><option value="This Week">Due This Week</option>
                              <option value={moment(new Date(Date.now())).format("MM/DD/YYYY")}>Late</option></>}
                          <option value="All">All</option>
                        </select>
                      </div>
                    </div>
                    {/* <div className={workloadUpdateFilter != "Claim Scrubber" ? "col-auto flex-grow-1" : "col-md-6"}> */}
                    <div className="col-auto flex-grow-1">
                      <div className="d-flex align-items-center gap-2">
                        <label htmlFor="filter" className="font-face-futura">Update Filter:</label>
                        <select className="copyDrop1" value={workloadUpdateFilter} onChange={this.handleWorkloadUpdateFilter}>
                          <option value="Claim Scrubber">Claim Scrubber</option>
                          <option value="Denial Management">Denial Management</option>
                          <option value="No Response Management">No Response Management</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="dashbaordsection-layout h-100 chartpadding-bottom">
                    <div className="barChartWorkload text-white font-face-futura">
                      Worklist
                    </div>
                    <div className="bar-chart-Content cstm-chart worklistchart">
                      <BarChart data={dataofGraph} practiceData={practiceData} table={workloadUpdateFilter} />
                    </div>
                  </div>
                  <div className="total-chart-count text-end pb-1 px-3 bg-light w-100">
                    <p className="m-0" style={{ fontSize: 14 }}><b>Total Encounters:</b> <span>{totalEncounters}</span></p>
                  </div>
                </Card>
              </div>

              <div className="col-lg-6 col-sm-6 mb-3">
                <Card className="workLoadCard h-100">
                  <CardHeader
                    className="workLoadHead"
                    title={
                      <h5 className="text-white font-face-futura">
                        Pass Through Rate
                      </h5>
                    }
                  ></CardHeader>
                  <div className="mt-3 row w-100 px-3">
                    <div className="col-md-6">
                      <div className="d-flex align-items-center gap-2">
                        <label htmlFor="user" className="font-face-futura">Practice:</label>
                        <select className="copyDrop1">
                          <option key="0" value="0">All Practices</option>
                          {practiceData.filter(x => x.status === true).map((practice) => (
                            <option key={practice.id} value={practice.id}>{practice.practiceName}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-center gap-2">
                        <label htmlFor="filter" className="font-face-futura">Update Filter:</label>
                        <select className="copyDrop1" value={workloadUpdateFilter} onChange={this.handleWorkloadUpdateFilter}>
                          <option value="denial">Denial Management</option>
                          <option value="noResponse">No Response Management</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="dashbaordsection-layout piechart-section ">
                    <div className="barChartWorkload text-white font-face-futura">
                      {metrics.title}
                    </div>
                    {/*<div className="bar-chart-Content">
                      <BarChart data={dataofGraph} practiceData={practiceData} />
                    </div>*/}
                    <div className="providerCard">
                      <div className="col-lg-12 col-sm-12">
                        <div className="row">
                          <div className="col-lg-3 col-sm-3 cleanPieChart">
                            <p className="claimsPerc">
                              {metrics.rate}%
                            </p>
                            <p className="violatedText" style={{ color: "#954437" }}>
                              {metrics.denials} Denials
                            </p>
                            <p className="approveText">
                              {metrics.resolved} Resolved
                            </p>
                          </div>
                          <div className="col-lg-9 col-sm-9 mt-5">
                            <div style={{ height: '250px' }}>
                              <StackedBarChart
                                data={data}
                                options={options}
                                scrollDirection="backward"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-end  px-3 w-100 mt-2">
                      <p className="m-0" style={{ fontSize: 14 }}><b>Last Updated:</b> <span>{new Date(Date.now()).toLocaleDateString('en-US')}</span></p>
                    </div>
                  </div>
                </Card>
              </div>

              {/* <div className="col-lg-6 col-sm-6 mb-3">
                <Card className="autorunCard">
                  <CardHeader
                    className="workLoadHead"
                    title={
                      <h5 className="text-white font-face-futura">
                        Auto-Run
                      </h5>
                    }
                  ></CardHeader>
                  <CardContent className="dashbaordsection-layout">
                    <div className="table-responsive manageAutoRun">
                      <table className="tableAutorun">
                        <thead>
                          <tr>
                            {autoRun.map((col, index) => (
                              <th
                                className="text-white font-face-furura"
                                key={index}
                              >
                                {col.name}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {practiceData.filter(x => x.status === true).map((practice) => (
                            <tr
                              key={practice.id}
                              className="table-row">
                              <td style={{ textAlign: "center" }}>
                                <div className="innerdata">
                                  <span
                                    title=""
                                    className="one-line-ellipsis"
                                  >
                                    {practice.practiceName}
                                  </span>
                                </div>
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <div className="innerdata">
                                  <span
                                    title=""
                                    className="one-line-ellipsis"
                                  >
                                    {practice.autoRunRules === true
                                      ? "On"
                                      : "Off"}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </CardContent>
                </Card>
              </div> */}

              <div className="col-lg-6 col-sm-6 mb-3">
                <Card className="workLoadCard h-100">
                  <CardHeader
                    className="workLoadHead"
                    title={
                      <h5 className="text-white font-face-futura">
                        Worked vs Entered
                      </h5>
                    }
                  ></CardHeader>
                  <div className="mt-3 row align-items-center justify-content-end w-100 px-3">
                    <div className="col-auto">
                      <div className="d-flex align-items-center gap-2">
                        <label htmlFor="filter" className="font-face-futura">Update Filter:</label>
                        <select className="copyDrop1" value={workvsenterFilter} onChange={this.handleWorkVsEnterFilter}>
                          <option value="denial">Denial Management</option>
                          <option value="noResponse">No Response Management</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="dashbaordsection-layout">
                    <div className="barChartWorkload text-white font-face-futura">
                      Last 90 Days
                    </div>
                    {wedata && weoptions && <div className="bar-chart-Content p-2" style={{ height: '535px' }}>
                      <StackedBarChart
                        data={wedata}
                        options={weoptions}
                        scrollDirection="forward"
                      />
                    </div>}
                  </div>
                </Card>
              </div>

              <div className="col-lg-6 col-sm-6 mb-3 toptentable-container">
                <Card className="workLoadCard h-100">
                  <CardHeader
                    className="workLoadHead"
                    title={
                      <h5 className="text-white font-face-futura">
                        Top Ten - Worklist
                      </h5>
                    }
                  ></CardHeader>
                  <div className="mt-3 row w-100 px-3">
                    <div className="col-md-6">
                      <div className="d-flex align-items-center gap-2">
                        <label htmlFor="user" className="font-face-futura">Practice:</label>
                        <select className="copyDrop1" value={topTenPractice} onChange={this.handleTopTenPracticeFilter}>
                          <option value="0">All Practices</option>
                          {practiceData.filter(x => x.status === true).map((practice) => (
                            <option key={practice.id} value={practice.id}>{practice.practiceName}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-center gap-2">
                        <label htmlFor="filter" className="font-face-futura">Update Filter:</label>
                        <select className="copyDrop1" value={topTenFilter} onChange={this.handleTopTenFilter}>
                          <option value="denial">Denial Management</option>
                          <option value="noresp">No Response Management</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <CardContent className="toptentable-layout h-100">
                    <div className={`table-responsive manageAutoRun topten-table ${topTenFilter == 'denial' ? " top-ten-table" : "top-non-table"}`}>
                      <table className="tableAutorun">
                        <thead>
                          <tr>
                            {(topTenFilter == 'denial' ? topTenD : topTenN).map((col, index) => (
                              <th
                                className="text-white font-face-furura"
                                key={index}
                              >
                                {col.name}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {topTenWorklist.length > 0 && topTenWorklist?.map((top) => (
                            <tr
                              key={top.id}
                              className="table-row">
                              {topTenFilter == 'denial' && <td style={{ textAlign: "center" }}>
                                <div className="innerdata">
                                  <span title="" className="one-line-ellipsis">{top.Remark}</span>
                                </div>
                              </td>}
                              <td style={{ textAlign: "center" }}>
                                <div className="innerdata">
                                  <span className="text-truncate" data-bs-toggle="tooltip" data-bs-placement="bottom" title={topTenFilter == 'denial' ? top.Description : top.Billed_to}>
                                    {topTenFilter == 'denial' ? top.Description : top.Billed_to}
                                  </span>
                                </div>
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <div className="innerdata">
                                  <span title="" className="one-line-ellipsis">{top.rowCount}</span>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {/* <tr
                            className="table-row">
                            {topTenFilter == 'denial' && <td style={{ textAlign: "center" }}>
                              <div className="innerdata">
                                <span title="" className="one-line-ellipsis">{"29"}</span>
                              </div>
                            </td>}
                            <td style={{ textAlign: "center" }}>
                              <div className="innerdata">
                                <span className="text-truncate" data-bs-toggle="tooltip" data-bs-placement="bottom" title={"Outpatient services are not covered when performed within a period of time prior to or after..."}>
                                  {"Outpatient services are not covered when performed within a period of time prior to or after..."}
                                </span>
                              </div>
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <div className="innerdata">
                                <span title="" className="one-line-ellipsis">{"38"}</span>
                              </div>
                            </td>
                          </tr> */}
                        </tbody>
                      </table>
                    </div>
                  </CardContent>
                </Card>
              </div>

              <div className="col">
                <Card className="processCard" style={{ height: (filterBy == "assignedVsAssignedTo" || processedUpdateFilter == "claimScrubber") ? "610px" : "700px" }}>
                  <CardHeader
                    className="processCardHead"
                    title={
                      <h5 className="text-white font-face-futura">
                        Processed Volume
                      </h5>
                    }
                  />
                  <CardContent className="dashbaordsection-layout">
                    <div className="row align-items-center justify-content-between">
                      {processedUpdateFilter !== "claimScrubber" &&
                        <div className={`col-md-2 `}>
                          <div className="d-flex align-items-center gap-2">
                            <label htmlFor="user" className="font-face-futura">Filter by:</label>
                            <select className="copyDrop1" value={filterBy} onChange={this.handleFilterBy}>
                              <option value="workedVsEntered">Worked vs Entered</option>
                              <option value="assignedVsAssignedTo">Assigned vs Assigned To</option>
                            </select>
                          </div>
                        </div>}
                      {processedUpdateFilter !== "claimScrubber" &&
                        <div className="col-md-2">
                          <div className="d-flex align-items-center gap-2">
                            <label htmlFor="user" className="font-face-futura">Filter by User:</label>
                            <select className="copyDrop1" value={filterByUser} onChange={this.handleFilterByUser}>
                              {filterBy != "assignedVsAssignedTo" ? <option>All Users</option> : <option>Select</option>}
                              {pvUsers.map((item) => (
                                <option>{item.fullName}</option>
                              ))}
                            </select>
                          </div>
                        </div>}
                      <div className={`${processedUpdateFilter == "claimScrubber" ? 'col-md-4' : 'col-md-3'}`}>
                        <div className="d-flex align-items-center gap-2">
                          <label htmlFor="filter" className="font-face-futura">Update Filter:</label>
                          <select className="copyDrop1 px-2" value={processedUpdateFilter} onChange={this.handleProcessedFilter}>
                            <option value="denial">Denial Management</option>
                            <option value="noResponse">No Response Management</option>
                            <option value="claimScrubber">Claim Scrubber</option>
                          </select>
                        </div>
                      </div>
                      <div className={`${processedUpdateFilter == "claimScrubber" ? 'col-md-4' : 'col-md-3'}`}>
                        <div className={`d-flex align-items-center gap-2 workedbyuser-select justify-content-start`}>
                          <label
                            htmlFor="volume"
                            className="font-face-futura"
                          >
                            Practice:
                          </label>

                          <select
                            className="practiceDropdown text-center"
                            onChange={this.handlePracticeChange}
                            // defaultValue={practice.practiceName}
                            value={practiceFilter}
                          >
                            <option key="0" value="0">All Practices</option>
                            {practiceData.map((practice) => (
                              <option value={practice.id} key={practice.id}>
                                {practice.practiceName}
                              </option>
                            ))}
                          </select>

                          {/* <div className="practice-filter flex-grow-1">
                            <PracticeSelect
                              setSidebarDisable={false}
                              hasAllPracticeOption={true}
                              handleChangePractice={(practice) => {
                                // this.getProcessedClaimsGraph()
                                this.getProcessedByVolumeGraph()
                                this.state.customSetPractice(
                                  practice.id ? practice.id : practice
                                );
                              }}
                            />
                          </div> */}

                        </div>
                      </div>
                      <div className={`${processedUpdateFilter == "claimScrubber" ? 'col-md-4' : 'col-md-2'}`}>
                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="dateRange"
                            className="font-face-futura"
                          >
                            Date Range:
                          </label>
                          <select
                            className="dateRangeSelct text-center"
                            id="dateRange"
                            // onChange={this.handleDateRangeGraph}
                            onChange={this.handleMonthToDate}
                            defaultValue={'month_to_date'}
                          >
                            {dateRange.map((date) => (
                              <option key={date.value} value={date.key}>
                                {date.value}
                              </option>
                            ))}
                          </select>
                        </div>
                        {/* </div> */}
                      </div>
                    </div>
                    <div className="mt-3 processedClaims text-white font-face-futura">
                      Processed Claims
                    </div>
                    <div className="chartLine">
                      {/* <LineChart data={dataOfProcessedClaims} /> */}
                      {/* <DashBoardChart/> */}
                      {loading && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            width: "100%",
                          }}

                        >
                          <CircularProgress size={20} />
                        </Box>
                      )}
                      {!loading && hasData && (
                        <div className="processed-linechart">
                          <LineCharts
                            graphData={graphData}
                            analysis={processVolumeData?.analysis}
                            updateFilter={processedUpdateFilter}
                            filterBy={filterBy}
                            filterByUser={filterByUser}
                          />
                        </div>
                      )}
                      {!loading && !hasData && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100px",
                            width: "100%",
                          }}
                        >
                          <Typography variant="body1" sx={{ marginTop: 1 }}>
                            No graph data available.
                          </Typography>
                        </Box>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div >
        </section >
      </>
    );
  }
}

export default Dashboard;